import { render, staticRenderFns } from "./MemberStatisticsInfo.vue?vue&type=template&id=ed8d20fa&scoped=true&"
import script from "./MemberStatisticsInfo.vue?vue&type=script&lang=js&"
export * from "./MemberStatisticsInfo.vue?vue&type=script&lang=js&"
import style0 from "./MemberStatisticsInfo.vue?vue&type=style&index=0&id=ed8d20fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8d20fa",
  null
  
)

export default component.exports